module.exports = __webpack_public_path__ + "img/greenarw.c019c6a8.svg";